import React from 'react';

import List from './List';

const Ol: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => <List as="ol">{children}</List>;

export default Ol;
